<template>
  <!-- 审核通过卡片 -->
  <div class="audit-pass-card">
    <!-- 返回 -->
    <button type="button" class="back-btn" @click="handleBack">
      <svg viewBox="0 0 24 24" width="20" height="20">
        <path
          d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
          fill="currentColor"
        />
      </svg>
      {{ $t("approved.back") }}
    </button>

    <!-- 成功图标 -->
    <div class="success-icon">
      <div class="icon-circle">
        <svg viewBox="0 0 24 24" width="64" height="64">
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
            fill="currentColor"
          />
        </svg>
      </div>
      <div class="success-line"></div>
    </div>

    <!-- 标题 -->
    <div class="audit-header">
      <h1 class="title">{{ $t("approved.title") }}</h1>
      <p class="subtitle">{{ $t("approved.subtitle") }}</p>
    </div>

    <!-- 权益说明 -->
    <div class="benefits-section">
      <h3 class="benefits-title">{{ $t("approved.benefitsTitle") }}</h3>
      <div class="benefits-grid">
        <div class="benefit-item">
          <div class="benefit-icon">✅</div>
          <span class="benefit-text">{{ $t("approved.benefit1") }}</span>
        </div>
        <div class="benefit-item">
          <div class="benefit-icon">🚀</div>
          <span class="benefit-text">{{ $t("approved.benefit2") }}</span>
        </div>
        <div class="benefit-item">
          <div class="benefit-icon">💎</div>
          <span class="benefit-text">{{ $t("approved.benefit3") }}</span>
        </div>
        <div class="benefit-item">
          <div class="benefit-icon">🎯</div>
          <span class="benefit-text">{{ $t("approved.benefit4") }}</span>
        </div>
      </div>
    </div>

    <!-- 操作按钮 -->
    <div class="audit-actions">
      <button class="action-btn primary" @click="handleGoDashboard">
        <svg viewBox="0 0 24 24" width="18" height="18">
          <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" fill="currentColor" />
        </svg>
        {{ $t("approved.login") }}
      </button>
      <!-- <button class="action-btn secondary" @click="handleBack">返回首页</button> -->
    </div>

    <!-- 底部 -->
    <!-- <div class="audit-footer">
      <p>如有疑问，请联系技术支持</p>
      <a href="#" class="contact-link" @click.prevent="handleContact">
        support@example.com
      </a>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "AuditPassPage",
  data() {
    return {
      userInfo: {
        realName: "张三",
        email: "zhangsan@example.com",
        phone: "138****1234",
        idNumber: "440***********001X",
        auditTime: "2024-01-15 14:30:00",
      },
    };
  },
  created() {
    // 从路由参数或接口获取用户信息
    // this.fetchUserInfo();
  },
  methods: {
    handleBack() {
      this.$router.push({ name: "Home" });
    },
    handleGoDashboard() {
      this.$router.push({ name: "Login" });
    },
    handleContact() {
      window.location.href = "mailto:support@example.com";
    },
    async fetchUserInfo() {
      try {
        // const res = await this.$api.user.getAuditInfo();
        // this.userInfo = res.data;
      } catch (error) {
        console.error("获取用户信息失败:", error);
      }
    },
  },
};
</script>

<style scoped>
/* ===== 容器 ===== */
.audit-pass-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 20px;
}

/* ===== 背景图层 ===== */
.bg-layer {
  position: absolute;
  inset: 0;
  background-image: url("@/assets/imgs/dlbj.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transform: scale(1.05);
  z-index: 0;
}

/* ===== 审核通过卡片 ===== */
.audit-pass-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 520px;
  padding: 40px 44px 32px;
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(24px) saturate(180%);
  -webkit-backdrop-filter: blur(24px) saturate(180%);
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  text-align: center;
  transition: all 0.3s ease;
}

.audit-pass-card:hover {
  border-color: rgba(100, 200, 255, 0.2);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.6), 0 0 60px rgba(0, 150, 255, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);
}

/* ===== 返回按钮 ===== */
.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
  cursor: pointer;
  padding: 4px 0;
  transition: all 0.3s ease;
  font-family: inherit;
  margin-bottom: 16px;
}

.back-btn:hover {
  color: #00b4ff;
  transform: translateX(-4px);
}

/* ===== 成功图标 ===== */
.success-icon {
  margin: 8px 0 16px;
  position: relative;
}

.icon-circle {
  width: 96px;
  height: 96px;
  margin: 0 auto;
  background: linear-gradient(
    135deg,
    rgba(0, 230, 118, 0.15),
    rgba(0, 200, 100, 0.05)
  );
  border: 3px solid rgba(0, 230, 118, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: pulse-icon 2s ease-in-out infinite;
  position: relative;
}

.icon-circle svg {
  color: #00e676;
}

@keyframes pulse-icon {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 230, 118, 0.3);
  }
  50% {
    transform: scale(1.03);
    box-shadow: 0 0 40px 10px rgba(0, 230, 118, 0.1);
  }
}

.success-line {
  width: 60px;
  height: 2px;
  margin: 12px auto 0;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(0, 230, 118, 0.3),
    transparent
  );
}

/* ===== 标题 ===== */
.audit-header {
  margin-bottom: 24px;
}

.title {
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 6px;
  letter-spacing: 1px;
  text-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
}

.subtitle {
  font-size: 14px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}

/* ===== 用户信息卡片 ===== */
.user-info-card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 24px;
  text-align: left;
}

.info-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
  font-weight: 400;
}

.info-value {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 500;
}

/* ===== 权益说明 ===== */
.benefits-section {
  margin-bottom: 28px;
}

.benefits-title {
  font-size: 15px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  margin: 0 0 14px;
  letter-spacing: 0.5px;
}

.benefits-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.benefit-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 10px 14px;
  transition: all 0.3s ease;
}

.benefit-item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(0, 230, 118, 0.2);
}

.benefit-icon {
  font-size: 18px;
}

.benefit-text {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.65);
  font-weight: 400;
}

/* ===== 操作按钮 ===== */
.audit-actions {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
}

.action-btn {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 20px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.action-btn.primary {
  background: linear-gradient(135deg, #00e676, #00c853);
  color: #fff;
  box-shadow: 0 4px 20px rgba(0, 230, 118, 0.25);
}

.action-btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 230, 118, 0.35);
}

.action-btn.primary:active {
  transform: translateY(0);
}

.action-btn.secondary {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.action-btn.secondary:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  transform: translateY(-2px);
}

.action-btn.secondary:active {
  transform: translateY(0);
}

/* ===== 底部 ===== */
.audit-footer {
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.audit-footer p {
  color: rgba(255, 255, 255, 0.3);
  font-size: 13px;
  margin: 0 0 4px;
}

.contact-link {
  color: #00b4ff;
  text-decoration: none;
  font-size: 13px;
  transition: color 0.3s;
}

.contact-link:hover {
  color: #66ccff;
  text-decoration: underline;
}

/* ===== 响应式适配 ===== */
@media (max-width: 520px) {
  .audit-pass-card {
    padding: 28px 20px 24px;
    border-radius: 16px;
    margin: 12px;
  }

  .title {
    font-size: 22px;
  }

  .subtitle {
    font-size: 13px;
  }

  .icon-circle {
    width: 72px;
    height: 72px;
  }

  .icon-circle svg {
    width: 48px;
    height: 48px;
  }

  .benefits-grid {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .benefit-item {
    padding: 8px 10px;
  }

  .benefit-text {
    font-size: 12px;
  }

  .audit-actions {
    flex-direction: column;
    gap: 10px;
  }

  .action-btn {
    padding: 12px 16px;
  }

  .info-row {
    flex-direction: column;
    gap: 2px;
    padding: 6px 0;
  }

  .info-label {
    font-size: 12px;
  }

  .info-value {
    font-size: 13px;
  }

  .bg-layer {
    filter: blur(8px) brightness(0.6);
    -webkit-filter: blur(8px) brightness(0.6);
  }
}

@media (max-width: 380px) {
  .audit-pass-card {
    padding: 20px 14px 18px;
  }

  .title {
    font-size: 19px;
  }

  .benefits-grid {
    grid-template-columns: 1fr 1fr;
    gap: 6px;
  }

  .benefit-item {
    padding: 6px 8px;
  }

  .benefit-icon {
    font-size: 15px;
  }

  .benefit-text {
    font-size: 11px;
  }

  .icon-circle {
    width: 60px;
    height: 60px;
  }

  .icon-circle svg {
    width: 36px;
    height: 36px;
  }
}
</style>
